import React from 'react';
import InputLabel, {InputLabelProps} from '@material-ui/core/InputLabel';
import {makeStyles} from '@material-ui/core/styles';

const LoginInputLabel = (props: InputLabelProps) => {
  const css = useStyles();
  const className = css.inputLabel + ' ' + (props.className ?? '');
  return <InputLabel {...props} className={className} />;
};

const useStyles = makeStyles(() => ({
  inputLabel: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: 10,
    color: '#000',
  },
}));

export default LoginInputLabel;
